import { DEFAULT_PX_PER_M } from "../cableEditGeometry";
import type { RouteWaypoint } from "../../../ReviewPage/hooks/useCircuitCablePaths/types";
import type { CircuitMetres } from "./types";

const SEGMENT_PRECISION = 2;

const segmentKey = (from: RouteWaypoint, to: RouteWaypoint): string => {
  const point = (p: RouteWaypoint) =>
    `${p.x.toFixed(SEGMENT_PRECISION)},${p.y.toFixed(SEGMENT_PRECISION)}`;
  const [a, b] = [point(from), point(to)];
  return a < b ? `${a}|${b}` : `${b}|${a}`;
};

export const circuitMetres: CircuitMetres = ({
  paths,
  imageScaleFactor,
  scalePxPerM,
}) => {
  // Every path starts at the board, so summing them bills the shared trunk
  // once per device — a circuit is one cable, so count each segment once.
  const counted = new Set<string>();
  let lengthInPoints = 0;

  for (const { waypoints } of paths) {
    for (let index = 1; index < waypoints.length; index++) {
      const from = waypoints[index - 1];
      const to = waypoints[index];
      const key = segmentKey(from, to);
      if (counted.has(key)) continue;
      counted.add(key);
      lengthInPoints += Math.hypot(to.x - from.x, to.y - from.y);
    }
  }

  return (lengthInPoints * (imageScaleFactor || 1)) / (scalePxPerM || DEFAULT_PX_PER_M);
};
